/**
 * The hotel's own mark, from the supplied artwork.
 *
 * The image itself lives in styles/brand.css as a greyscale mask, painted with
 * the copper token, so the logo is always exactly the same copper as the rest
 * of the interface and the light theme's darker copper comes for free. See the
 * comment at the top of that file.
 *
 * `shield` is the mark alone, for the rail, where the product name sits beside
 * it. `lockup` is the mark with the wordmark, for the sign-in card, which is
 * the one place the hotel should introduce itself in full.
 */
export function Crest({
  width = 46,
  variant = 'shield',
}: {
  width?: number
  variant?: 'shield' | 'lockup'
}) {
  return (
    <div
      className={`brandmark ${variant}`}
      style={{ width }}
      role="img"
      aria-label="The Fellows House"
    />
  )
}
